<div class="bpaas-content">

  <form [formGroup]="formGroup">
    <div class="card" #contentElement pBPaaSFocusTrap>
      <!-- Search Tab Menu -->
      <p-tabMenu #searchTabMenuComponent [model]="searchTabs" [activeItem]="activeSearchTab"
        styleClass="bpaas-table-tabmenu" (activeItemChange)="onSearchTabActiveItemChange($event)">
      </p-tabMenu>

      <!-- search Tab -->
      <ng-container *ngIf="activeSearchTab?.id === this.parseToId('search')">
        <p-panel [showHeader]="false">
          <div class="grid p-fluid">
            <!-- OU -->
            <div class="col-12 md:col-3 lg:col-3">
              <label [for]="parseToId('ouFormControlName')" class="bpaas-required">
                {{ "field.ou" | translate }}
              </label>
              <p-autoComplete *ngIf="langChangeVisible" [suggestions]="ouSuggestions" [forceSelection]="true"
                [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
                emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchOuSuggestions($event)"
                (onClear)="autoCompleteCleared('autoCompleteCode')" (onFocus)="autoCompleteFocus($event)"
                (onBlur)="autoCompleteBlur($event)" (onKeyUp)="autoCompleteKeyUp($event)"
                (onSelect)="autoCompleteCompleted('autoCompleteCode')" dataKey="value" appendTo="body"
                formControlName="ouFormControlName" [inputId]="parseToId('ouFormControlName')" field="label">
              </p-autoComplete>
              <div *ngIf="formControlInvalid('ouFormControlName')">
                <small class="p-error" *ngIf="formControl('ouFormControlName').errors?.['required']">
                  {{ "message.validation.required" | translate }}
                </small>
              </div>
            </div>

            <!-- Item -->
            <div class="col-12 md:col-3 lg:col-3">
              <label [for]="parseToId('itemFormControlName')" class="bpaas-required">
                {{ "field.item-number" | translate }}
              </label>
              <p-autoComplete *ngIf="langChangeVisible" [suggestions]="itemSuggestions" [forceSelection]="true"
                [minLength]="3" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
                emptyMessage="{{ 'table.no-records-found' | translate }}"
                (completeMethod)="searchItemSuggestions($event)" (onClear)="autoCompleteCleared('autoCompleteCode')"
                (onFocus)="autoCompleteFocus($event)" (onBlur)="autoCompleteBlur($event)"
                (onKeyUp)="autoCompleteKeyUp($event)" (onSelect)="autoCompleteCompleted('autoCompleteCode')"
                dataKey="value" formControlName="itemFormControlName" [inputId]="parseToId('itemFormControlName')"
                field="label" appUppercase appTrimInput>
              </p-autoComplete>
              <div *ngIf="formControlInvalid('itemFormControlName')">
                <small class="p-error" *ngIf="formControl('itemFormControlName').errors?.['required']">
                  {{ "message.validation.required" | translate }}
                </small>
              </div>
            </div>

            <!-- Begin Month -->
            <div class="col-12 md:col-3 lg:col-3">
              <label [for]="parseToId('beginMonthFormControlName')" class="bpaas-required">
                {{ "field.begin-month" | translate }}
              </label>
              <input type="text" pInputText maxlength="6" formControlName="beginMonthFormControlName"
                [id]="parseToId('beginMonthFormControlName')" inputmode="numeric" pKeyFilter="int" />
              <div
                *ngIf="formControlInvalid('beginMonthFormControlName') || (submitted && formGroup.errors?.['monthRangeInvalid'])">
                <small class="p-error" *ngIf="formControl('beginMonthFormControlName').errors?.['required']">
                  {{ "message.validation.required" | translate }}
                </small>

                <small class="p-error" *ngIf="formControl('beginMonthFormControlName').errors?.['monthFormat']">
                  {{ "message.validation.begin-month-format" | translate }}
                </small>

                <small class="p-error" *ngIf="submitted && formGroup.errors?.['monthRangeInvalid']">
                  {{ "message.validation.begin-month-less-end-month" | translate }}
                </small>
              </div>
            </div>

            <!-- End Month -->
            <div class="col-12 md:col-3 lg:col-3">
              <label [for]="parseToId('endMonthFormControlName')" class="bpaas-required">
                {{ "field.end-month" | translate }}
              </label>
              <input type="text" pInputText maxlength="6" formControlName="endMonthFormControlName"
                [id]="parseToId('endMonthFormControlName')" inputmode="numeric" pKeyFilter="int" />
              <div *ngIf="formControlInvalid('endMonthFormControlName')">
                <small class="p-error" *ngIf="formControl('endMonthFormControlName').errors?.['required']">
                  {{ "message.validation.required" | translate }}
                </small>
                <small class="p-error" *ngIf="formControl('endMonthFormControlName').errors?.['monthFormat']">
                  {{ "message.validation.end-month-format" | translate }}
                </small>
              </div>
            </div>
          </div>

          <!-- Buttons -->
          <div class="grid p-fluid justify-content-end bpaas-button-row">
            <div class="col-12 md:col-3 lg:col-2">
              <button type="button" pButton label="{{ 'button.reset' | translate }}" class="p-button-outlined mr-2"
                (click)="searchReset()" [id]="parseToId('btnReset')"></button>
            </div>
            <div class="col-12 md:col-3 lg:col-2">
              <button type="button" pButton label="{{ 'button.query' | translate }}" (click)="submitQuery()"
                [id]="parseToId('btnQuery')"></button>
            </div>
          </div>
        </p-panel>
      </ng-container>

      <!-- searchResult Tab -->
      <ng-container *ngIf="activeSearchTab?.id === this.parseToId('searchResult')">
        <p-panel [showHeader]="false">
          <div class="grid p-fluid">
            <!-- 處理狀態 -->
            <div class="col-12 md:col-3 lg:col-3">
              <label [for]="parseToId('processStatusFormControlName')">
                {{ "field.processing-status" | translate }}
              </label>

              <p-dropdown *ngIf="langChangeVisible" [options]="processStatusOptions" optionLabel="label"
                optionValue="value" placeholder="{{ 'option.please-select' | translate }}" [showClear]="true"
                appendTo="body" formControlName="processStatusFormControlName"
                [inputId]="parseToId('processStatusFormControlName')">
              </p-dropdown>
            </div>

            <!-- Batch Id -->
            <div class="col-12 md:col-3 lg:col-3">
              <label [for]="parseToId('batchIdFormControlName')">
                {{ "field.batch-id" | translate }}
              </label>
              <input type="text" pInputText formControlName="batchIdFormControlName"
                [id]="parseToId('batchIdFormControlName')" />
            </div>

            <!-- 建立日期 -->
            <div class="col-12 md:col-3 lg:col-3">
              <label [for]="parseToId('createDateFormControlName')">
                {{ "field.create-date" | translate }}
              </label>

              <p-calendar [showIcon]="true" appendTo="body" formControlName="createDateFormControlName"
                dateFormat="yy/mm/dd" placeholder="yyyy/mm/dd"
                [maxDate]="formGroup.get('endDateFormControlName')?.value"
                [inputId]="parseToId('createDateFormControlName')" [showOnFocus]="false"
                [ngClass]="{'ng-dirty':formControlInvalid('createDateFormControlName')}">
              </p-calendar>
              <div *ngIf="formControlInvalid('createDateFormControlName')">
                <small class="p-error" *ngIf="formControl('createDateFormControlName').errors?.['required']">
                  {{ 'message.validation.required' | translate }}
                </small>

                <small class="p-error" *ngIf="formControl('createDateFormControlName').errors?.['dateRangeInvalid']">
                  <!-- 日期範圍有誤 -->
                  {{ "message.validation.date-range-invalid" | translate }}
                </small>
              </div>
            </div>

            <!-- 結束日期 -->
            <div class="col-12 md:col-3 lg:col-3">
              <label [for]="parseToId('endDateFormControlName')">
                {{ "field.end-date" | translate }}
              </label>
              <p-calendar [showIcon]="true" appendTo="body" formControlName="endDateFormControlName"
                dateFormat="yy/mm/dd" placeholder="yyyy/mm/dd"
                [minDate]="formGroup.get('createDateFormControlName')?.value"
                [inputId]="parseToId('endDateFormControlName')" [showOnFocus]="false"
                [ngClass]="{ 'ng-dirty':formControlInvalid('endDateFormControlName') }">
              </p-calendar>

              <div *ngIf="formControlInvalid('endDateFormControlName')">
                <small class="p-error" *ngIf="formControl('endDateFormControlName').errors?.['required']">
                  {{ 'message.validation.required' | translate }}
                </small>
                <small class="p-error" *ngIf="formControl('endDateFormControlName').errors?.['dateRangeInvalid']">
                  <!-- 日期範圍有誤 -->
                  {{ "message.validation.date-range-invalid" | translate }}
                </small>
              </div>


            </div>
          </div>

          <!-- Buttons -->
          <div class="grid p-fluid justify-content-end bpaas-button-row">
            <div class="col-12 md:col-3 lg:col-2">
              <button type="button" pButton label="{{ 'button.reset' | translate }}" class="p-button-outlined mr-2"
                (click)="resultReset()" [id]="parseToId('btnResultReset')"></button>
            </div>
            <div class="col-12 md:col-3 lg:col-2">
              <button type="button" pButton label="{{ 'button.query' | translate }}" (click)="queryResult()"
                [id]="parseToId('btnResultQuery')"></button>
            </div>
          </div>
        </p-panel>
      </ng-container>

      <!-- searchResult -->
      <ng-container *ngIf="activeSearchTab?.id === this.parseToId('searchResult')">
        <p-panel [showHeader]="false">
          <!-- Table Component -->
          <p-table #tableComponent *ngIf="langChangeVisible" [value]="detailDatas"
            styleClass="p-datatable-gridlines p-datatable-sm p-datatable-striped" [paginator]="true"
            [paginatorDropdownAppendTo]="'body'" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="{{
        'table.paginator'
          | translate
            : {
                first: '{first}',
                last: '{last}',
                totalRecords: '{totalRecords}'
              }
      }}" [rowsPerPageOptions]="[10, 20, 50]" [resizableColumns]="true" columnResizeMode="expand"
            [columns]="selectedColumns">
            <!-- Table Header -->
            <ng-template pTemplate="header" let-columns>
              <tr id="bpaas-table-header">
                <!-- Table Header Columns -->
                <th *ngFor="let column of columns" [pSortableColumn]="column.sortable ? column.field : ''"
                  [pSortableColumnDisabled]="column.sortable ? false : true"
                  [style]="column.width ? 'width: ' + column.width + 'px' : ''" pResizableColumn>
                  <label [class]="column.required ? 'bpaas-required' : ''">
                    {{ column.header | translate }}
                  </label>
                  <p-sortIcon *ngIf="column.sortable" [field]="column.field"></p-sortIcon>
                </th>
              </tr>
            </ng-template>

            <!-- Table Body -->
            <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
              <tr [id]="parseToId('rowData-' + rowIndex)">
                <!-- Table Body Data Display -->
                <td *ngFor="let column of columns" [class]="column.numberField ? 'bpaas-align-right' : ''"
                  [id]="parseToId('rowData-' + rowIndex + '-' + column.field)">
                  <ng-container *ngIf="column.translateDataValueField">
                    {{
                    rowData[column.field]
                    | translateDataValue
                    : rowData
                    : column.translateDataValueField
                    }}
                  </ng-container>
                  <ng-container *ngIf="column.translateArrayValue">
                    {{
                    rowData[column.field]
                    | translateArrayValue
                    : column.translateArrayValue.datas
                    : column.translateArrayValue.valueField
                    : column.translateArrayValue.displayField
                    }}
                  </ng-container>
                  <ng-container *ngIf="column.numberField">
                    {{
                    rowData[column.field] ??
                    (column.numberFieldDefaultZero ? 0 : "") | dynamicDecimal
                    }}
                  </ng-container>
                  <ng-container *ngIf="column.dateField">
                    {{
                    rowData[column.field]
                    | date
                    : (column.dateFormat ? column.dateFormat : "yyyy/MM/dd")
                    : "GMT+8"
                    }}
                  </ng-container>
                  <ng-container *ngIf="column.customField">
                    <!-- 如果有需要條件判斷處理值的，自己寫在這段裡面 -->
                  </ng-container>
                  <ng-container *ngIf="
  !column.customField &&
  !column.translateDataValueField &&
  !column.translateArrayValue &&
  !column.numberField &&
  !column.dateField
">
                    <ng-container *ngIf="column.field === 'batchId'; else normalText">

                      <a class="link" href="javascript:void(0)" (click)="openBatchIdDetail(rowData)"
                        *ngIf="rowData.processStatus === 'F'; else normalText">
                        {{ rowData[column.field] }}
                      </a>

                      <span class="pi pi-info-circle info" (click)="overlay.toggle($event)"
                        (keydown)="handleKeyDown($event)" [id]="parseToId('btnBatchInfo-' + rowIndex)"
                        tabindex="0"></span>

                      <p-overlayPanel #overlay>
                        <div>OU : {{rowData.request?.ouId }}</div>
                        <div>Item Number : {{rowData.request?.itemNumber }}</div>
                        <div>Begin Month : {{rowData.request?.beginMonth }}</div>
                        <div>End Month : {{rowData.request?.endMonth }}</div>
                      </p-overlayPanel>
                    </ng-container>

                    <ng-template #normalText>
                      {{ rowData[column.field] }}
                    </ng-template>
                  </ng-container>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>
      </ng-container>
    </div>

    <!-- Batch Dialog -->
    <p-dialog [(visible)]="displayBatchDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
      [style]="{ width: '30rem' }">
      <div class="success-container flex flex-column">
        <div class="container-body p-3">
          <div class="success-message-container text-center">
            <h4>{{ 'message.detail.batchid-success-info' | translate: { batchId } }}
              <div>{{ 'message.detail.batchid-success-result' | translate}}</div>
            </h4>
          </div>
        </div>
        <div class="button text-center p-2">
          <button type="button" pButton label="{{ 'button.confirm' | translate }}"
            (click)="onBatchDialogConfirm()"></button>
        </div>
      </div>

    </p-dialog>
  </form>

</div>